import React, { useState } from 'react'
import { AccordionCardWithDialogButtonProps } from './AccordionCardWithDialogButtonTypes'
import { Button } from '@mui/material';

const AccordionCardWithDialogButton = ({
    buttonLabel,
    DialogComponent,
    dialogProps = {},
    icon,
}: AccordionCardWithDialogButtonProps) => {
    const [open, setOpen] = useState(false);
    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                startIcon={icon}
                onClick={() => setOpen(true)}
                sx={{ mb: 2 }}
            >
                {buttonLabel}
            </Button>
            <DialogComponent
                open={open}
                onClose={() => setOpen(false)}
                {...dialogProps}
            />
        </div>
    )
}

export default AccordionCardWithDialogButton